// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cap01-section {
    background: #D8D8D8 ;
    color: #1E1E1E;
    box-sizing: border-box;
    position: relative;
  
    /* ⬅️ INI KUNCI INTRO & OUTRO */
    padding: 5vh calc(6 * var(--vw));
    overflow-x: hidden;
    overflow-y: visible;
    width: 100%;
    max-width: calc(100 * var(--vw));
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    min-height: 100vh;
    margin: 0;
  }
  
  /* Scroll hint */
.cap01-scroll {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.6;
    font-size: 14px;
  }
  
  /* List */
.cap01-list {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    width: 100%;
    gap: 0;
  }

.cap01-list-horizontal {
    flex-direction: row;
    flex-wrap: nowrap;
    gap: calc(1.5 * var(--vw));
    align-items: flex-start;
    justify-content: flex-start;
  }

  .cap01-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
  }

.cap01-num {
    font: 500 normal clamp(28px, calc(5 * var(--vw)), 90px) / 0.9 "Satoshi", sans-serif;
    letter-spacing: -0.06em;
  }

  .cap01-num-bottom {
    margin-top: calc(3 * var(--vw));
    align-self: flex-start;
  }

  .cap01-video {
    position: absolute;
    right: calc(10 * var(--vw));
    bottom: calc(8 * var(--vw));
    width: min(calc(32 * var(--vw)), 420px);
    aspect-ratio: 1.6;
    object-fit: cover;
    border-radius: 8px;
  }

  .cap01-paragraph {
    margin-top: calc(10 * var(--vw));
    max-width: 900px;
    font: 500 normal clamp(22px, calc(3.4 * var(--vw)), 34px) / 1.5 "Satoshi", sans-serif;
    letter-spacing: -0.02em;
  }

  .cap01-note {
    margin-top: calc(2 * var(--vw));
    max-width: 760px;
    font: 400 italic clamp(16px, calc(2.2 * var(--vw)), 22px) / 1.5 "Satoshi", sans-serif;
    opacity: 0.85;
  }

/* Desktop Windows (<= 1366px) */
@media (max-width: 1366px) {
  .cap01-paragraph {
    max-width: 720px;
    font-size: clamp(18px, calc(2.6 * var(--vw)), 26px);
    margin-top: calc(7 * var(--vw));
  }

  .cap01-note {
    max-width: 640px;
    font-size: clamp(14px, calc(2 * var(--vw)), 20px);
    margin-top: calc(2 * var(--vw));
  }

  .cap01-video {
    right: calc(6 * var(--vw));
    bottom: calc(6 * var(--vw));
    width: min(calc(30 * var(--vw)), 360px);
  }
  }
  
  /* Row */
.cap01-list li {
    font: 500 clamp(32px, calc(7 * var(--vw)), 120px) / 0.9 "Satoshi", sans-serif;
    letter-spacing: -0.06em;
    display: flex;
    overflow: hidden;
    width: auto;
    max-width: none;
    justify-content: center;
    align-items: center;
  }

.cap01-list-horizontal li {
    overflow: visible;
  }

.cap01-list-horizontal .cap01-letter span:last-child {
    opacity: 0;
    pointer-events: none;
  }
  
  /* Letter */
.cap01-letter {
    position: relative;
    display: inline-block;
  }
  
  /* Duplicate letter */
.cap01-letter span:last-child {
    position: absolute;
    bottom: 100%;
    left: 0;
  }

  /* Space */
.cap01-space {
    display: inline-block;
    width: 0.2em; /* Adjust spacing width as needed */
  }

/* ==================== MEDIA QUERIES ==================== */

/* Mobile (max-width: 768px) */
@media screen and (max-width: 768px) {
  section.cap01-section {
    padding: 8vh calc(4 * var(--vw)) 15vh !important;
    min-height: auto !important;
    height: auto !important;
    justify-content: flex-start !important;
    margin: 0 !important;
    margin-top: -5vh !important; /* Compensate for previous section's padding */
    box-sizing: border-box !important;
    position: relative;
    z-index: 1 !important;
    background: #D8D8D8 !important; /* Ensure background stays visible */
  }

  section.cap01-section .cap01-scroll {
    display: none !important;
  }

  section.cap01-section .cap01-header {
    flex-direction: column !important;
    gap: 1.5vh !important;
    align-items: flex-start !important;
    position: relative !important;
  }

  section.cap01-section .cap01-list {
    gap: 0.5rem !important;
    margin: 0 !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    padding: 0 !important;
    width: 100% !important;
    box-sizing: border-box !important;
    flex-wrap: wrap !important;
  }

  section.cap01-section .cap01-list li {
    font-size: clamp(28px, calc(8 * var(--vw)), 48px) !important;
    font-weight: 600 !important;
    line-height: 1.1 !important;
    letter-spacing: -0.04em !important;
    padding: 0.25rem 0 !important;
    margin: 0 !important;
    width: auto !important;
    max-width: none !important;
    text-align: left !important;
    display: flex !important;
    justify-content: flex-start !important;
    align-items: flex-start !important;
    overflow: hidden !important;
    box-sizing: border-box !important;
  }

  section.cap01-section .cap01-letter {
    display: inline-block !important;
    position: relative !important;
  }

  section.cap01-section .cap01-letter span:last-child {
    position: absolute !important;
    bottom: 100% !important;
    left: 0 !important;
  }

  section.cap01-section .cap01-paragraph {
    margin-top: 6vh !important;
    font-size: clamp(16px, calc(4.4 * var(--vw)), 20px) !important;
    max-width: 100% !important;
  }

  section.cap01-section .cap01-note {
    margin-top: 2vh !important;
    font-size: clamp(13px, calc(3.6 * var(--vw)), 18px) !important;
    max-width: 100% !important;
  }

  section.cap01-section .cap01-num-bottom {
    font-size: clamp(20px, calc(6 * var(--vw)), 32px) !important;
    position: absolute !important;
    top: 6vh !important;
    right: calc(5 * var(--vw)) !important;
    align-self: auto !important;
  }

  section.cap01-section .cap01-video {
    position: relative !important;
    right: auto !important;
    bottom: auto !important;
    margin-top: 4vh !important;
    width: 100% !important;
    max-width: 100% !important;
  }
}

/* Small Mobile (max-width: 480px) */
@media screen and (max-width: 480px) {
  section.cap01-section {
    padding: 6vh calc(3 * var(--vw)) 12vh !important;
    margin-top: -3vh !important; /* Compensate for previous section's padding */
    background: #D8D8D8 !important; /* Ensure background stays visible */
  }

  section.cap01-section .cap01-list {
    padding: 0 0.5rem !important;
    gap: 0.3rem !important;
  }

  section.cap01-section .cap01-list li {
    font-size: clamp(24px, calc(8 * var(--vw)), 40px) !important;
    padding: 0.4rem 0 !important;
    line-height: 1.2 !important;
  }

  section.cap01-section .cap01-paragraph {
    margin-top: 5vh !important;
    font-size: clamp(15px, calc(4.8 * var(--vw)), 18px) !important;
  }

  section.cap01-section .cap01-note {
    margin-top: 2vh !important;
    font-size: clamp(12px, calc(4.2 * var(--vw)), 16px) !important;
  }

  section.cap01-section .cap01-num-bottom {
    font-size: clamp(18px, calc(6 * var(--vw)), 28px) !important;
  }
}

/* iPhone Landscape (max-width: 896px dan max-height: 500px) */
@media screen and (max-width: 896px) and (max-height: 500px) and (orientation: landscape) {
  section.cap01-section {
    padding: 4vh calc(4 * var(--vw)) 8vh !important;
    background: #D8D8D8 !important; /* Ensure background stays visible */
  }

  section.cap01-section .cap01-list {
    gap: 0.2rem !important;
  }

  section.cap01-section .cap01-list li {
    font-size: clamp(48px, calc(10 * var(--vw)), 72px) !important;
  }
}
  `, "",{"version":3,"sources":["webpack://./src/component/capability-01/capability-01.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;;IAElB,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,mBAAmB;IACnB,WAAW;IACX,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,iBAAiB;IACjB,SAAS;EACX;;EAEA,gBAAgB;AAClB;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,eAAe;EACjB;;EAEA,SAAS;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,2BAA2B;IAC3B,WAAW;IACX,MAAM;EACR;;AAEF;IACI,mBAAmB;IACnB,iBAAiB;IACjB,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,WAAW;EACb;;AAEF;IACI,mFAAmF;IACnF,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,2BAA2B;IAC3B,uCAAuC;IACvC,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,gCAAgC;IAChC,gBAAgB;IAChB,qFAAqF;IACrF,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;IAC/B,gBAAgB;IAChB,qFAAqF;IACrF,aAAa;EACf;;AAEF,gCAAgC;AAChC;EACE;IACE,gBAAgB;IAChB,mDAAmD;IACnD,+BAA+B;EACjC;;EAEA;IACE,gBAAgB;IAChB,iDAAiD;IACjD,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,2BAA2B;IAC3B,uCAAuC;EACzC;EACA;;EAEA,QAAQ;AACV;IACI,6EAA6E;IAC7E,uBAAuB;IACvB,aAAa;IACb,gBAAgB;IAChB,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,mBAAmB;EACrB;;AAEF;IACI,iBAAiB;EACnB;;AAEF;IACI,UAAU;IACV,oBAAoB;EACtB;;EAEA,WAAW;AACb;IACI,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,qBAAqB;AACvB;IACI,kBAAkB;IAClB,YAAY;IACZ,OAAO;EACT;;EAEA,UAAU;AACZ;IACI,qBAAqB;IACrB,YAAY,EAAE,mCAAmC;EACnD;;AAEF,4DAA4D;;AAE5D,8BAA8B;AAC9B;EACE;IACE,gDAAgD;IAChD,2BAA2B;IAC3B,uBAAuB;IACvB,sCAAsC;IACtC,oBAAoB;IACpB,2BAA2B,EAAE,8CAA8C;IAC3E,iCAAiC;IACjC,kBAAkB;IAClB,qBAAqB;IACrB,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,iCAAiC;IACjC,qBAAqB;IACrB,kCAAkC;IAClC,6BAA6B;EAC/B;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,sCAAsC;IACtC,kCAAkC;IAClC,qBAAqB;IACrB,sBAAsB;IACtB,iCAAiC;IACjC,0BAA0B;EAC5B;;EAEA;IACE,4DAA4D;IAC5D,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;IAClC,6BAA6B;IAC7B,oBAAoB;IACpB,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,wBAAwB;IACxB,sCAAsC;IACtC,kCAAkC;IAClC,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE,gCAAgC;IAChC,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,8DAA8D;IAC9D,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,8DAA8D;IAC9D,0BAA0B;EAC5B;;EAEA;IACE,4DAA4D;IAC5D,6BAA6B;IAC7B,mBAAmB;IACnB,qCAAqC;IACrC,2BAA2B;EAC7B;;EAEA;IACE,6BAA6B;IAC7B,sBAAsB;IACtB,uBAAuB;IACvB,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;EAC5B;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gDAAgD;IAChD,2BAA2B,EAAE,8CAA8C;IAC3E,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;;EAEA;IACE,4DAA4D;IAC5D,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;IAC1B,8DAA8D;EAChE;;EAEA;IACE,0BAA0B;IAC1B,8DAA8D;EAChE;;EAEA;IACE,4DAA4D;EAC9D;AACF;;AAEA,8DAA8D;AAC9D;EACE;IACE,+CAA+C;IAC/C,8BAA8B,EAAE,oCAAoC;EACtE;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,6DAA6D;EAC/D;AACF","sourcesContent":[".cap01-section {\n    background: #D8D8D8 ;\n    color: #1E1E1E;\n    box-sizing: border-box;\n    position: relative;\n  \n    /* ⬅️ INI KUNCI INTRO & OUTRO */\n    padding: 5vh calc(6 * var(--vw));\n    overflow-x: hidden;\n    overflow-y: visible;\n    width: 100%;\n    max-width: calc(100 * var(--vw));\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    min-height: 100vh;\n    margin: 0;\n  }\n  \n  /* Scroll hint */\n.cap01-scroll {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    opacity: 0.6;\n    font-size: 14px;\n  }\n  \n  /* List */\n.cap01-list {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 100%;\n    gap: 0;\n  }\n\n.cap01-list-horizontal {\n    flex-direction: row;\n    flex-wrap: nowrap;\n    gap: calc(1.5 * var(--vw));\n    align-items: flex-start;\n    justify-content: flex-start;\n  }\n\n  .cap01-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 100%;\n  }\n\n.cap01-num {\n    font: 500 normal clamp(28px, calc(5 * var(--vw)), 90px) / 0.9 \"Satoshi\", sans-serif;\n    letter-spacing: -0.06em;\n  }\n\n  .cap01-num-bottom {\n    margin-top: calc(3 * var(--vw));\n    align-self: flex-start;\n  }\n\n  .cap01-video {\n    position: absolute;\n    right: calc(10 * var(--vw));\n    bottom: calc(8 * var(--vw));\n    width: min(calc(32 * var(--vw)), 420px);\n    aspect-ratio: 1.6;\n    object-fit: cover;\n    border-radius: 8px;\n  }\n\n  .cap01-paragraph {\n    margin-top: calc(10 * var(--vw));\n    max-width: 900px;\n    font: 500 normal clamp(22px, calc(3.4 * var(--vw)), 34px) / 1.5 \"Satoshi\", sans-serif;\n    letter-spacing: -0.02em;\n  }\n\n  .cap01-note {\n    margin-top: calc(2 * var(--vw));\n    max-width: 760px;\n    font: 400 italic clamp(16px, calc(2.2 * var(--vw)), 22px) / 1.5 \"Satoshi\", sans-serif;\n    opacity: 0.85;\n  }\n\n/* Desktop Windows (<= 1366px) */\n@media (max-width: 1366px) {\n  .cap01-paragraph {\n    max-width: 720px;\n    font-size: clamp(18px, calc(2.6 * var(--vw)), 26px);\n    margin-top: calc(7 * var(--vw));\n  }\n\n  .cap01-note {\n    max-width: 640px;\n    font-size: clamp(14px, calc(2 * var(--vw)), 20px);\n    margin-top: calc(2 * var(--vw));\n  }\n\n  .cap01-video {\n    right: calc(6 * var(--vw));\n    bottom: calc(6 * var(--vw));\n    width: min(calc(30 * var(--vw)), 360px);\n  }\n  }\n  \n  /* Row */\n.cap01-list li {\n    font: 500 clamp(32px, calc(7 * var(--vw)), 120px) / 0.9 \"Satoshi\", sans-serif;\n    letter-spacing: -0.06em;\n    display: flex;\n    overflow: hidden;\n    width: auto;\n    max-width: none;\n    justify-content: center;\n    align-items: center;\n  }\n\n.cap01-list-horizontal li {\n    overflow: visible;\n  }\n\n.cap01-list-horizontal .cap01-letter span:last-child {\n    opacity: 0;\n    pointer-events: none;\n  }\n  \n  /* Letter */\n.cap01-letter {\n    position: relative;\n    display: inline-block;\n  }\n  \n  /* Duplicate letter */\n.cap01-letter span:last-child {\n    position: absolute;\n    bottom: 100%;\n    left: 0;\n  }\n\n  /* Space */\n.cap01-space {\n    display: inline-block;\n    width: 0.2em; /* Adjust spacing width as needed */\n  }\n\n/* ==================== MEDIA QUERIES ==================== */\n\n/* Mobile (max-width: 768px) */\n@media screen and (max-width: 768px) {\n  section.cap01-section {\n    padding: 8vh calc(4 * var(--vw)) 15vh !important;\n    min-height: auto !important;\n    height: auto !important;\n    justify-content: flex-start !important;\n    margin: 0 !important;\n    margin-top: -5vh !important; /* Compensate for previous section's padding */\n    box-sizing: border-box !important;\n    position: relative;\n    z-index: 1 !important;\n    background: #D8D8D8 !important; /* Ensure background stays visible */\n  }\n\n  section.cap01-section .cap01-scroll {\n    display: none !important;\n  }\n\n  section.cap01-section .cap01-header {\n    flex-direction: column !important;\n    gap: 1.5vh !important;\n    align-items: flex-start !important;\n    position: relative !important;\n  }\n\n  section.cap01-section .cap01-list {\n    gap: 0.5rem !important;\n    margin: 0 !important;\n    justify-content: flex-start !important;\n    align-items: flex-start !important;\n    padding: 0 !important;\n    width: 100% !important;\n    box-sizing: border-box !important;\n    flex-wrap: wrap !important;\n  }\n\n  section.cap01-section .cap01-list li {\n    font-size: clamp(28px, calc(8 * var(--vw)), 48px) !important;\n    font-weight: 600 !important;\n    line-height: 1.1 !important;\n    letter-spacing: -0.04em !important;\n    padding: 0.25rem 0 !important;\n    margin: 0 !important;\n    width: auto !important;\n    max-width: none !important;\n    text-align: left !important;\n    display: flex !important;\n    justify-content: flex-start !important;\n    align-items: flex-start !important;\n    overflow: hidden !important;\n    box-sizing: border-box !important;\n  }\n\n  section.cap01-section .cap01-letter {\n    display: inline-block !important;\n    position: relative !important;\n  }\n\n  section.cap01-section .cap01-letter span:last-child {\n    position: absolute !important;\n    bottom: 100% !important;\n    left: 0 !important;\n  }\n\n  section.cap01-section .cap01-paragraph {\n    margin-top: 6vh !important;\n    font-size: clamp(16px, calc(4.4 * var(--vw)), 20px) !important;\n    max-width: 100% !important;\n  }\n\n  section.cap01-section .cap01-note {\n    margin-top: 2vh !important;\n    font-size: clamp(13px, calc(3.6 * var(--vw)), 18px) !important;\n    max-width: 100% !important;\n  }\n\n  section.cap01-section .cap01-num-bottom {\n    font-size: clamp(20px, calc(6 * var(--vw)), 32px) !important;\n    position: absolute !important;\n    top: 6vh !important;\n    right: calc(5 * var(--vw)) !important;\n    align-self: auto !important;\n  }\n\n  section.cap01-section .cap01-video {\n    position: relative !important;\n    right: auto !important;\n    bottom: auto !important;\n    margin-top: 4vh !important;\n    width: 100% !important;\n    max-width: 100% !important;\n  }\n}\n\n/* Small Mobile (max-width: 480px) */\n@media screen and (max-width: 480px) {\n  section.cap01-section {\n    padding: 6vh calc(3 * var(--vw)) 12vh !important;\n    margin-top: -3vh !important; /* Compensate for previous section's padding */\n    background: #D8D8D8 !important; /* Ensure background stays visible */\n  }\n\n  section.cap01-section .cap01-list {\n    padding: 0 0.5rem !important;\n    gap: 0.3rem !important;\n  }\n\n  section.cap01-section .cap01-list li {\n    font-size: clamp(24px, calc(8 * var(--vw)), 40px) !important;\n    padding: 0.4rem 0 !important;\n    line-height: 1.2 !important;\n  }\n\n  section.cap01-section .cap01-paragraph {\n    margin-top: 5vh !important;\n    font-size: clamp(15px, calc(4.8 * var(--vw)), 18px) !important;\n  }\n\n  section.cap01-section .cap01-note {\n    margin-top: 2vh !important;\n    font-size: clamp(12px, calc(4.2 * var(--vw)), 16px) !important;\n  }\n\n  section.cap01-section .cap01-num-bottom {\n    font-size: clamp(18px, calc(6 * var(--vw)), 28px) !important;\n  }\n}\n\n/* iPhone Landscape (max-width: 896px dan max-height: 500px) */\n@media screen and (max-width: 896px) and (max-height: 500px) and (orientation: landscape) {\n  section.cap01-section {\n    padding: 4vh calc(4 * var(--vw)) 8vh !important;\n    background: #D8D8D8 !important; /* Ensure background stays visible */\n  }\n\n  section.cap01-section .cap01-list {\n    gap: 0.2rem !important;\n  }\n\n  section.cap01-section .cap01-list li {\n    font-size: clamp(48px, calc(10 * var(--vw)), 72px) !important;\n  }\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
